import { render, staticRenderFns } from "./DataTablePagination.vue?vue&type=template&id=7d6f9f3b&scoped=true&"
import script from "./DataTablePagination.vue?vue&type=script&lang=js&"
export * from "./DataTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./DataTablePagination.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DataTablePagination.vue?vue&type=style&index=1&id=7d6f9f3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6f9f3b",
  null
  
)

export default component.exports